<template>
  <v-overlay :opacity="0.99" :color="instance.theme.preload_background"  class="overlay-bck" >
    <div class="text-center">
      <img :src="instance.preload.logo" class="mx-auto" width="180"/>
      <h3><b color="black">{{ $t('common.loading_label') }}...</b></h3>
      <v-progress-circular indeterminate size="50" />
    </div>
  </v-overlay>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoaderSplash",
  computed: {
    ...mapState('customer', ["instance"])
  }
};
</script>
